"use client"

import { router, usePage } from "@inertiajs/react"
import { LogOut01, Settings01 } from "@untitledui/icons"

import { AvatarLabelGroup } from "@/components/ui/avatar-label-group"
import { Dropdown } from "@/components/ui/dropdown-menu"
import { sessionPath, settingsProfilePath } from "@/routes"
import type { SharedData } from "@/types"

export const UserMenu = () => {
  const { visitor } = usePage<SharedData>().props

  // The user-menu only renders for authenticated visitors (the
  // marketing layout's navbar shows sign-in CTAs to anonymous and
  // guest visitors). Bail defensively in case a layout misroutes.
  if (!visitor.authenticated || !visitor.session_id) return null

  return (
    <Dropdown.Root>
      <Dropdown.Trigger className="hover:bg-surface-elevated/60 flex w-full min-w-0 items-center gap-3 rounded-lg p-2 text-left outline-none hover:cursor-pointer focus-visible:ring-2 focus-visible:ring-offset-2">
        <AvatarLabelGroup
          size="md"
          name={visitor.display_name ?? ""}
          avatarUrl={visitor.avatar_url}
          title={visitor.display_name ?? ""}
          subtitle={visitor.email ?? ""}
          className="min-w-0 flex-1"
        />
      </Dropdown.Trigger>
      <Dropdown.Popover>
        <Dropdown.Menu>
          <Dropdown.Item
            icon={Settings01}
            label="Settings"
            href={settingsProfilePath()}
          />
          <Dropdown.Separator />
          <Dropdown.Item
            icon={LogOut01}
            label="Log out"
            onAction={() =>
              router.delete(sessionPath({ id: visitor.session_id! }))
            }
          />
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown.Root>
  )
}
